import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { loginUser } from '../api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const { token } = await loginUser(email, password);
      if (token) {
        localStorage.setItem('token', token);
      }
      navigate('/dashboard');
    } catch (err) {
      setError(err.message || 'Login failed');
    }
  };

  return (
    <div className="login-landing-bg">
      <div className="login-landing-container">
        <div className="login-landing-left">
          <div className="login-brand-row">
            <span className="login-brand-logo">II</span>
            <span className="login-brand-name">VisaInterviewDemo</span>
          </div>
          <h1 className="login-landing-title">The most realistic Visa Interview AI platform</h1>
          <p className="login-landing-subtitle">Experience the next generation of AI-powered visa interview practice, with realistic voice and 3D avatars.</p>
          <div className="login-landing-btn-row">
            <button className="login-cta-btn" onClick={() => document.getElementById('login-form-card').scrollIntoView({behavior:'smooth'})}>Get Started Free</button>
            <a className="login-sales-btn" href="#contact" tabIndex={-1}>Talk to Sales</a>
          </div>
          <div className="login-landing-trusted">
            <span>Trusted by:</span>
            <div className="login-landing-logos">
              <span className="login-logo-placeholder">Synthflow</span>
              <span className="login-logo-placeholder">TIME</span>
              <span className="login-logo-placeholder">NVIDIA</span>
              <span className="login-logo-placeholder">Chess.com</span>
            </div>
          </div>
        </div>
        <div className="login-landing-right" id="login-form-card">
          <div className="auth-container login-form-card">
            <h2>Login</h2>
            <form onSubmit={handleSubmit}>
              <label>Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} required />
              <label>Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} required />
              <button type="submit">Login</button>
              {error && <div className="error">{error}</div>}
            </form>
            <div style={{marginTop: 12}}>
              <Link to="/register">Don't have an account? Register</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
